// County filtering functionality
document.addEventListener("DOMContentLoaded", function () {
	const container = document.querySelector(".js-select-office-by-county");
	if (!container) return;

	const countyRadios = container.querySelectorAll('input[name="selection"]');
	const officeSections = container.querySelectorAll("[data-county]");
	const officesSection = container.querySelector("#offices-by-county");

	if (!countyRadios.length || !officesSection) return;

	function filterOfficesByCounty(selectedCounty) {
		officeSections.forEach((section) => {
			const county = section.getAttribute("data-county");

			if (county === selectedCounty) {
				section.style.display = "";
			} else {
				section.style.display = "none";
			}
		});
	}

	// Add event listeners to radio buttons
	countyRadios.forEach((radio) => {
		radio.addEventListener("change", function () {
			if (this.checked) {
				filterOfficesByCounty(this.value);
			}
		});
	});

	// Initialize: hide all offices by default
	officeSections.forEach((section) => {
		section.style.display = "none";
	});
});
